<template>
  <button
    class="w-auto me-2 btn btn-secondary"
    :title="$t('settings')"
    @click="toggleDialogVisibility"
  >
    <font-awesome-icon icon="fa-solid fa-gear" />
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SettingsBtn',
  methods: {
    toggleDialogVisibility() {
      this.$store.commit('epoch/toggleDialogSetting', 'visibility');
    }
  }
});
</script>
